import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/service/batch_assign'

/**
 * @description: 获取符合条件的导游派单信息
 * @param {*} params
 * @return {*}
 */
export function getGuideList(data) {
  return axios.post(`${ApiUrl}/guide_list/`, data)
}

/**
 * @description: 待添加游客订单列表
 * @param {*} params
 * @return {*}
 */
export function getWaitOrderList(data) {
  return axios.post(`${ApiUrl}/wait_order_list/`, data)
}

/**
 * @description: 添加游客
 * @return {*}
 */
export function addTourist(data) {
  return axios.post(`${ApiUrl}/order_add/`, data)
}

/**
 * @description: 一键派单
 * @return {*}
 */
export function assignSubmit(data) {
  return axios.post(`${ApiUrl}/assign_submit/`, data)
}

/**
 * @description: 获取派单详情
 * @param {*} data
 * @return {*}
 */
export function getAssignDetail(data) {
  return axios.post(`${ApiUrl}/assign_detail/`, data)
}
